var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueFragment',[_c('SiteHeader'),_c('div',{staticClass:"router-view"},[_c('router-view')],1),_c('SiteFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }